import { Work } from '@mui/icons-material';
import { Badge, Box } from '@mui/material';
import React from 'react';
import { Card } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { formatDate } from '../../lib/utils';

const QuickLinks = ({ count = '0', redirectTo, heading, id }) => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '4px 12px 4px 0px',
        '&:hover': {
          cursor: 'pointer',
          color: 'primary.main',
          backgroundColor: '#f5f5f5',
        },
      }}
      onClick={() => navigate(`/project/${id}/${redirectTo}`)}
    >
      <Box
        sx={{
          flex: '1 1 auto',
          minWidth: 0,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {heading}
      </Box>
      <Badge
        badgeContent={count}
        color="info"
        sx={{
          ml: 2,
          '.MuiBadge-badge': {
            fontSize: '0.75rem',
            minWidth: '20px',
            height: '20px',
          },
        }}
      />
    </Box>
  );
};


const ProjectWidget = ({ project, minimal = false }) => {
  const {
    name,
    id: projectId,
    created_at,
    key,
    test_case_count,
    test_cycle_count,
  } = project;

  return (
    <Card style={{ maxHeight: '240px' }}>
      <Card.Body>
        <Card.Text className="d-flex justify-content-left" as="div">
          <div>
            <Work sx={{ color: 'orange' }} />
          </div>
          <div className="flex-grow-1">
            <div role="presentation" className="mx-2">
              <Link
                className="nowrap"
                to={`/project/${projectId}/dashboard`}
                reloadDocument
                title={name}>
                {`${key}- ${
                  name?.length > 20 ? `${name.substring(0, 20)}...` : name
                }`}
              </Link>
              {!minimal && (
                <p className="text-muted">
                  Created On: {formatDate(created_at)}
                </p>
              )}
            </div>

            {!minimal && (
              <>
                <p className="fw-bold text-muted">QUICK LINKS</p>
                <QuickLinks
                  redirectTo="testcases"
                  count={test_case_count || '0'}
                  heading="Test Cases"
                  id={projectId}
                />
                <QuickLinks
                  redirectTo="testcycles"
                  count={test_cycle_count || '0'}
                  heading="Test Cycles"
                  id={projectId}
                />
              </>
            )}
          </div>
        </Card.Text>
      </Card.Body>
    </Card>
  );
};

export default ProjectWidget;
